import React, { useRef, useState, useEffect } from 'react';
import * as echarts from 'echarts';
import { reportClick } from '@/utils/report';
import { setChartOptions } from '../const/chartOptions';
import { CHART_OPTION_TYPE_MAP } from '../const';
import styles from '../index.less';

const IncomeChart = ({
  tcbSum = 0,
  tcSum = 0,
  pageName,
  hideTitle = false,
  ctChartData,
  cbtChartData,
}) => {
  const chartRef = useRef(null);

  const [chartData, setChartData] = useState(ctChartData);
  const [curChartTypeOption, setCurChartTypeOption] = useState(CHART_OPTION_TYPE_MAP[0]);
  const reducerDate = date => {
    return date.replace(/(\d{4})(\d{2})(\d{2})/, (match, $1, $2, $3) => [$2, $3].join('-'));
  };

  const parseChartData = data => {
    let xAxisData = [],
      yAxisData = [],
      yAxisType = 'c';
    if (data && data.length > 0)
      if (curChartTypeOption === CHART_OPTION_TYPE_MAP[1]) {
        yAxisType = 'cb';
      }
    data.map(item => {
      xAxisData.push(reducerDate(item.d));
      yAxisData.push(item[yAxisType]);
    });
    return { xAxisData, yAxisData };
  };

  const handleChartOptionChange = option => {
    setCurChartTypeOption(option);
    // 设备总收益页面
    if (pageName === 'device_income') {
      reportClick({
        page_name: pageName,
        button_name:
          option === CHART_OPTION_TYPE_MAP[0]
            ? 'device_money_histogram_btn'
            : 'device_bean_histogram_btn',
      });
      // 用户总收益页面
    } else {
      reportClick({
        page_name: pageName,
        button_name:
          option === CHART_OPTION_TYPE_MAP[0]
            ? 'sum_money_histogram_btn'
            : 'sum_bean_histogram_btn',
      });
    }

    if (option === CHART_OPTION_TYPE_MAP[1]) {
      setChartData(cbtChartData);
    } else {
      setChartData(ctChartData);
    }
  };

  const chartOptions = CHART_OPTION_TYPE_MAP.map(option => (
    <li
      className={curChartTypeOption === option ? styles['on'] : ''}
      key={option}
      onClick={() => handleChartOptionChange(option)}
    >{`${option}`}</li>
  ));

  useEffect(() => {
    if (!chartData || chartData.length === 0) return;
    if (!chartRef.current) {
      chartRef.current = echarts.init(document.getElementById('incomeChart'));
    }
    let chartInstance = chartRef.current;
    if (!chartInstance || !chartData || chartData.length === 0) return;
    const { xAxisData, yAxisData } = parseChartData(chartData);
    const chartOption = setChartOptions({ xAxisData, yAxisData, curChartTypeOption });
    chartInstance.setOption(chartOption);
  }, [chartData, curChartTypeOption, parseChartData]);

  useEffect(() => {
    if (tcbSum === -1) {
      setCurChartTypeOption('现金');
      setChartData(ctChartData);
      return;
    }
    if (tcSum === -1) {
      setCurChartTypeOption('云豆');
      setChartData(cbtChartData);
      return;
    }
    if (curChartTypeOption === CHART_OPTION_TYPE_MAP[1]) {
      setChartData(cbtChartData);
    } else {
      setChartData(ctChartData);
    }
  }, [tcbSum, tcSum, ctChartData, cbtChartData, curChartTypeOption]);

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.dispose();
      }
    };
  }, []);

  return (
    <div>
      <div className={styles.userChartBox}>
        <div className={styles.userCharTit}>
          {!hideTitle && <h3>收益趋势</h3>}
          {tcbSum !== -1 && tcSum !== -1 && <ul className={styles.userCharTab}>{chartOptions}</ul>}
        </div>
        {ctChartData && ctChartData.length > 0 && (
          <div className={styles.userChar}>
            <div className={styles.userCharBox} id="incomeChart"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default IncomeChart;
